import appAxios from "services/axios";
import { BaseService } from "../_baseService";
import { toQueryParams } from "helpers/url";
import { CreateOrderDTO } from "services/DTO/orders.dto";

/**
 * @deprecated
 * Используйте SubOrdersAdminService вместо этого
 */
class BookingsAdminService extends BaseService<any> {
  constructor() {
    super(`bookings`);
  }

  /**
   * Создание заказа
   * @override
   * @param orderInput 
   * @returns 
   */
  post = (orderInput: CreateOrderDTO): Promise<any> => {
    return appAxios.post(`/admin/v2/orgs/${localStorage.getItem("orgID")}/bookings`, orderInput)
  };
  /**
   * Получение заказа
   * @override
   * @param id 
   * @returns 
   */
  get = (id: string): Promise<any> => {
    return appAxios.get(`/admin/v2/orgs/${localStorage.getItem("orgID")}/bookings/${id}`)
  };
  completeOrder = async (bookingID: string) => {
    return appAxios.post(`${this.pathWithOrg()}/${bookingID}/complete`, {});
  };
  cancelOrder = async (bookingID: string) => {
    return appAxios.post(`${this.pathWithOrg()}/${bookingID}/cancel`, {});
  };
  refundOrder = async (bookingID: string) => {
    return appAxios.post(`${this.pathWithOrg()}/${bookingID}/refund`, {});
  };
  count = async (queryParams = {}) => {
    const qp = toQueryParams(queryParams)
    return appAxios.get(`${this.pathWithOrg()}/count?${qp}`, {});
  };
  unpaidClients = async (format: string) => {
    return appAxios.get(`${this.pathWithOrg()}/unpaid-clients`, {});
  };
  hideOrShowPaymentDetails = async (bookingID: string, isPaymentDetailsHidden: boolean) => {
    return appAxios.post(`${this.pathWithOrg()}/${bookingID}/hide-or-show-payment-details`, { isPaymentDetailsHidden });
  };
}

export default new BookingsAdminService();
